<template>
    <div>
        <h4 class=" text-lg font-semibold text-black mb-2">{{ t('us.tenant.title') }}</h4>
        <div v-if="tenants.length" class="flex flex-col gap-2 max-h-[300px] overflow-y-auto">
            <div
                v-for="item in tenants"
                :key="item.tenant_id"
                @click="onSelect(item)"
                :class="{'opacity-50 pointer-events-none !cursor-not-allowed': !!getDisabledTooltipText(item)}"
                class=" border border-solid border-grey-40 rounded p-2 cursor-pointer "
            >
                {{ item.tenant_name }}

                <p v-if="!!getDisabledTooltipText(item)" class="text-xs" >
                    <span v-html="getDisabledTooltipText(item)"> </span>
                </p>

                <div class="mt-2 flex gap-2">
                    <span v-if="item.domain_restrict" class="th-badge">
                        {{ t('us.tenant.domain_restrict') }}
                    </span>
                    <span v-if="item.ip_restrict" class="th-badge">
                        {{ t('us.tenant.ip_restrict') }}
                    </span>
                    <span v-if="item.sso_restrict" class="th-badge">
                        {{ t('us.tenant.sso_restrict') }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useTenant } from '../composables/use-tenant';
import type { PostTenantSelectInfosItem } from '../types/tenant';
import { getTenantErrorCodes } from '../utils/get-tenant-error-code';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const { tenants, onSelect } = useTenant();

function getDisabledTooltipText(item: PostTenantSelectInfosItem) {
    const codes = getTenantErrorCodes(item)
    return codes.map(code => t(`us.tenant.disabled.${code}`)).join('<div style="margin-bottom: 8px"></div>');
}

</script>
